import { i18n } from 'next-i18next'

function getLocalizeImage(path) {
  return `/images/${i18n.language}/${path}`
}

export default getLocalizeImage
